import React from 'react';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import './styles.css';

const QualityPanel: React.FC = () => (
  <Container maxWidth="lg" sx={{ marginTop: 5, marginBottom: 10 }}>
    <Grid container spacing={6}>
      <Grid item sm={12} md={6}>
        <img
          alt="satisfied travellers"
          src="/images/quality.webp"
          className="quality"
        />
      </Grid>
      <Grid item sm={12} md={6} className="info_tile">
        <Typography variant="h5" color="text.secondary">
          We do undertake solutions with our expertise to make the occasion a
          memorable experience to you whilst adding more value to it.
          <br />
          <br />
          Your safety is our utmost concern right through out the period
          concerned.
        </Typography>
      </Grid>
    </Grid>
  </Container>
);

export default QualityPanel;
